import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk"; // Correct import for redux-thunk
import { combineReducers } from "redux";
import settingReducer from "./setting/setting.reducer"; // Import your setting reducer

// Combine your reducers
const reducers = combineReducers({
    setting: settingReducer,
});

// Create the root reducer
const rootReducer = (state, action) => {
    return reducers(state, action);
};

// Create the store with middleware
const store = createStore(
    rootReducer,
    applyMiddleware(thunk)
);

export default store; // Export the store as default
